module.exports = __webpack_public_path__ + "img/badge_gray_fia-scholarship.0b60fdf7.svg";